import { FC } from "react";
import styled, { css } from "styled-components";
import { Typography, TypographyVariant } from "../../../components/ui-kit";

export const Section = styled.div<{ withoutBottomLine?: boolean }>`
  display: grid;
  margin: 15px 0 15px;
  padding-bottom: 20px;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  ${({ withoutBottomLine }) =>
    !withoutBottomLine && "border-bottom: 1px solid #adb5bd"};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Row = styled.div<{ $inline?: boolean }>`
  display: flex;
  flex-direction: ${({ $inline }) => ($inline ? "row" : "column")};
  gap: ${({ $inline }) => ($inline ? "10px" : "5px")};
  align-items: ${({ $inline }) => ($inline ? "flex-start" : "stretch")};
`;

const linkCss = css`
  color: #027aff;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

const LabelRow = styled(Typography)<{ $inline?: boolean }>`
  color: rgba(0, 0, 0, 0.6);
  ${({ $inline }) =>
    $inline &&
    css`
      flex: 0 0 auto;
      min-width: min(200px, 38%);
      max-width: 48%;
    `}
`;
const ValueRow = styled(Typography)<{ link?: () => void; $inline?: boolean }>`
  ${({ link }) => !!link && linkCss}
  ${({ $inline }) =>
    $inline &&
    css`
      flex: 1;
      min-width: 0;
      word-break: break-word;
    `}
`;

export const FieldRow: FC<{
  label: string;
  value?: string | number | JSX.Element;
  link?: () => void;
  className?: string;
  /** Label and value on one horizontal line (label left, value right). */
  inline?: boolean;
}> = ({ label, value, link, className, inline }) => {
  return (
    <Row className={className} $inline={inline}>
      <LabelRow variant={TypographyVariant.BODY5} $inline={inline}>
        {label}
      </LabelRow>
      <ValueRow
        onClick={link}
        link={link}
        variant={TypographyVariant.BODY2}
        $inline={inline}
      >
        {value ?? "-"}
      </ValueRow>
    </Row>
  );
};
